var React = require('react');

function ChartCheckInline (props) {
    return React.createElement("g",props,React.createElement("path",{"d":"M10.998535,17.646484l-5.37207-5.373047l1.646973-1.646973l3.728516,3.728027l6.05957-5.999512l1.647461,1.646484\n\t\tL10.998535,17.646484z"}));
}

ChartCheckInline.defaultProps = {};

module.exports = ChartCheckInline;

ChartCheckInline.default = ChartCheckInline;
